import './style.css'
import { gsap } from 'gsap';
import { shuffleArray } from './functions';
import { AudioTestApp } from '@audio/index'; // TODO: remove for production
import { WorldHolder } from "./WorldHolder";
import { Assets } from './components/Assets';
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { LoadingManager, RepeatWrapping, TextureLoader, ClampToEdgeWrapping } from 'three';
import { modelsToLoad, loadingMessages, texturesToLoad } from "./constants";

export class CursedLibraryApp {
    constructor() {
        this.assets = new Assets();

        this.worldHolder = null;
        this.mousePos = { x: 0, y: 0, px: 0, py: 0, cx: 0, cy: 0 }
        this.winWidth = 0;
        this.winHeight = 0;

        this.loadingManager = new LoadingManager();
        this.loadingMessages = shuffleArray(loadingMessages);
        this.messageID = 0;
        this.minimalMode = false;

        this.initLoading();

        // TODO: remove for production
        window.addEventListener('keyup', (event) => {
            // if key is "a", create a new AudioTestApp instance

            switch (event.key) {
                case 'a':
                    if (!this.audioTestApp) {
                        this.audioTestApp = new AudioTestApp();
                    }

                    document.body.classList.toggle('audio-test');
                    break;
                case 'ArrowRight':
                    this.worldHolder.nextStep();
                    break;
                case 'ArrowLeft':
                    this.worldHolder.previousStep();
                    break;
                case 'x':
                    this.worldHolder.exitOrBack();
                    break;
                case 'ArrowDown':
                case 'ArrowUp':
                    this.worldHolder.focusOrEnterPortal();
                    break;
                case 'i':
                case '?':
                    this.worldHolder.uiPanels.toggleInfoPanel();
                    break;
                case 'e':
                    this.worldHolder.testEnd();
                    break;
                case 'm':
                    this.worldHolder.toggleMinimalMode();
                    break;
                case 'v':
                    this.worldHolder.toggleVoiceover();
                    break;
            }
        });
    }

    initLoading() {
        this.loadingManager.onStart = (url, itemsLoaded, itemsTotal) => {
        };

        this.loadingManager.onLoad = () => {
            this.loaderUI.remove();
            this.setup();
        };

        this.loadingManager.onError = (url) => {
            console.log('There was an error loading ' + url);
        };

        this.loadAssets();
    }

    loadAssets() {
        // Textures
        const textureLoader = new TextureLoader(this.loadingManager);

        texturesToLoad.forEach((obj) => {
            const key = obj.file.slice(0, -4);
            const repeat = obj.repeat;
            textureLoader.load(`./textures/${obj.file}`, texture => {
                this.updateLoadingMessage(key);
                texture.wrapS = texture.wrapT = (repeat) ? RepeatWrapping : ClampToEdgeWrapping;
                this.assets.setTexture({ key, texture });
            });
        });

        // GLB models
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('./draco/');

        modelsToLoad.forEach(file => {
            const loaderModel = new GLTFLoader(this.loadingManager);
            loaderModel.setDRACOLoader(dracoLoader);
            loaderModel.load(`./models/${file}`, (gltf) => {
                const key = file.slice(0, -4);
                this.updateLoadingMessage(file);
                this.assets[`${key}Model`] = gltf;
            },
                (xhr) => { },
                (error) => { console.log('An error happened with', file, error); });
        });
    }

    updateLoadingMessage(file) {
        this.loaderUI.innerHTML = `Loading</br> ${this.loadingMessages[this.messageID]}`; // <br />(${file}) debug
        this.messageID = (this.messageID + 1) % loadingMessages.length;
    }

    setup() {
        this.worldHolder = new WorldHolder({
            canvas: this.canvas,
            assets: this.assets
        });

        // Main DOM event listeners
        this.handleClick = this.handleClick.bind(this); // so we can remove it later

        window.addEventListener('resize', this.onWindowResize.bind(this));
        window.addEventListener('click', this.handleClick);
        document.addEventListener("mousemove", this.handleMouseMove.bind(this));

        // Show the start button
        gsap.to(this.startButton, { opacity: 1, duration: 2, delay: 3 });
        this.onWindowResize()
        this.worldHolder.start();
    }

    onWindowResize() {
        this.winWidth = window.innerWidth;
        this.winHeight = window.innerHeight;

        if (this.worldHolder) {
            this.worldHolder.resize();// (winWidth, winHeight)
        }
    }

    handleMouseMove(e) {
        const { mousePos, worldHolder, winWidth, winHeight } = this;

        mousePos.x = e.clientX;
        mousePos.y = e.clientY;
        mousePos.px = mousePos.x / winWidth * 2 - 1;
        mousePos.py = mousePos.y / winHeight * 2 - 1;
        mousePos.cx = mousePos.x - winWidth / 2;
        mousePos.cy = mousePos.y - winHeight / 2;

        if (worldHolder) {
            worldHolder.mouseMove(mousePos);
        }
    }

    handleClick() {
        window.removeEventListener('click', this.handleClick);

        this.worldHolder.enterLibrary();

        gsap.to(this.startButton, {
            opacity: 0,
            duration: 1,
            onComplete: () => this.startButton.remove(),
        });
    }

    get startButton() {
        return document.querySelector('.button-start');
    }

    get loaderUI() {
        return document.querySelector('.loader');
    }

    get canvas() {
        return document.querySelector('canvas.webgl');
    }
}